import firebase from "firebase/app"
import "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyBpR8bsH-BZnZfNTL4weXYf0kpeik5y1nI",
  authDomain: "api-based-apps.firebaseapp.com",
  projectId: "api-based-apps",
  storageBucket: "api-based-apps.firebasestorage.app",
  messagingSenderId: "310076273692",
  appId: "1:310076273692:web:cea43a59bba64f0591dbd9",
  measurementId: "G-BNGQ7W96B1",
}

// Reuse the default app if firebaseInit.js already initialized one elsewhere,
// otherwise initialize it here.
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

export async function uploadActivity(file) {
  const name = +new Date() + "-" + file?.name
  const metadata = { contentType: file.type }
  const ref = firebase.storage().ref("dexOct")
  const task = ref.child(name).put(file, metadata)

  try {
    const snapshot = await task
    return await snapshot.ref.getDownloadURL()
  } catch (error) {
    console.log(error)
    return null
  }
}